import AdminRouter from "@/@admin/router";
import { $api, RouterUtilClass } from "@/shared";
import { Opportunity, User } from "@/shared/interfaces";
import { ApiResourceResult } from "@/shared/vuex";
import { StoreOptions } from "vuex";

export interface AdminOpportunitiesVuexState extends ApiResourceResult<User> {
  opportunities?: Opportunity[];
  loading: boolean;
}

export const AdminOpportunitiesVuex: StoreOptions<AdminOpportunitiesVuexState> = {
  ...{ namespaced: true },
  state: {
    opportunities: undefined,
    loading: false,
  },
  mutations: {},
  actions: {
    /**
     * Fetches users
     * @param context
     */
    fetch(context) {
      context.state.loading = true;
      $api.admin
        .get<ApiResourceResult<Opportunity>>(
          `/v1/opportunities?${RouterUtilClass.extractQuery(AdminRouter)}`
        )
        .then(({data}) => {
          context.state.count = data.count;
          context.state.next = data.next;
          context.state.skipped = data.skipped;
          context.state.opportunities = data.resources;
          //   Vue.set
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
  },
  modules: {},
  //
  getters: {},
};
